export const getUpdatedParamValue = (
  currentValue: string | null,
  value: string,
): string => {
  let newValue = ''

  if (currentValue) {
    const values = currentValue.split(',')
    if (values.includes(value)) {
      newValue = values.filter(item => item !== value).join(',')
    } else {
      newValue = [...values, value].join(',')
    }
  } else {
    newValue = value
  }

  return newValue
}
